export default "__VITE_ASSET__2mQ2ufCy__"